import {
  buttonVariants,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@devhop/ui";
import { Link } from "@tanstack/react-router";
import type { LiveListItem } from "@/modules/cf-live/presentation/api/types";
import { formatDateTimeLocal } from "@/shared/lib/date-time";
import { LiveStatusBadge } from "./LiveStatusBadge";

type Props = {
  items: LiveListItem[];
  warehouseNames: Map<string, string>;
};

export function LiveListTable({ items, warehouseNames }: Props) {
  if (items.length === 0) {
    return <p className="text-muted-foreground text-sm">ຍັງບໍ່ມີງານຂາຍ</p>;
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>ງານຂາຍ</TableHead>
          <TableHead>ເພຈ</TableHead>
          <TableHead className="hidden xl:table-cell">ສາງ</TableHead>
          <TableHead>ສະຖານະ</TableHead>
          <TableHead className="text-right">ສິນຄ້າ</TableHead>
          <TableHead className="text-right">ອໍເດີ</TableHead>
          <TableHead className="hidden text-right lg:table-cell">ບັນທຶກລ່າສຸດ</TableHead>
          <TableHead />
        </TableRow>
      </TableHeader>
      <TableBody>
        {items.map((item) => (
          <TableRow key={`${item.kind}-${item.id}`}>
            <TableCell className="min-w-48 font-medium">
              <div>{item.title}</div>
              <p className="text-muted-foreground text-xs">
                {item.kind === "draft"
                  ? "ງານກຽມຂາຍ · ຍັງບໍ່ເປີດຮັບ CF"
                  : "Live / Feed"}
              </p>
            </TableCell>
            <TableCell>{item.pageName}</TableCell>
            <TableCell className="hidden xl:table-cell">
              {item.warehouseId
                ? (warehouseNames.get(item.warehouseId) ?? "—")
                : "—"}
            </TableCell>
            <TableCell>
              <LiveStatusBadge label={item.displayStatus} />
            </TableCell>
            <TableCell className="text-right">{item.productCount}</TableCell>
            <TableCell className="text-right">{item.orderCount}</TableCell>
            <TableCell className="hidden text-right text-muted-foreground text-xs lg:table-cell">
              {item.updatedAt ? formatDateTimeLocal(item.updatedAt) : "—"}
            </TableCell>
            <TableCell className="text-right">
              {item.kind === "draft" ? (
                <Link
                  to="/app/live/new"
                  search={{ draftId: item.id, pageId: item.pageId }}
                  className={buttonVariants({ variant: "outline", size: "sm" })}
                >
                  ຈັດການ
                </Link>
              ) : (
                <Link
                  to="/app/live/$id"
                  params={{ id: item.id }}
                  className={buttonVariants({ variant: "outline", size: "sm" })}
                >
                  ຈັດການ
                </Link>
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
